import { render, staticRenderFns } from "./loginGZ.vue?vue&type=template&id=1998bb18&scoped=true&"
import script from "./loginGZ.vue?vue&type=script&lang=js&"
export * from "./loginGZ.vue?vue&type=script&lang=js&"
import style0 from "./loginGZ.vue?vue&type=style&index=0&id=1998bb18&scoped=true&lang=css&"
import style1 from "./loginGZ.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1998bb18",
  null
  
)

export default component.exports